import { CSSProgressiveHighlight } from "@caisy/league";
import styled from "styled-components";

export const SAddMemberModalSectionTitlte = styled.div`
  ${CSSProgressiveHighlight};
  color: var(--text-04);
  text-transform: uppercase;
  margin-bottom: 16px;
`;
